export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6051.ef4ab199.jpg";